import * as React from 'react';

interface NoInfoMessageTypes {
	name?: string;
	message?: string;
}

const NoInfoMessage: React.FC<NoInfoMessageTypes> = ({ message, name }) => {
	return <div className="detail-prompt">{message ? message : <>There are no {name} at the moment</>}</div>;
};

export default NoInfoMessage;
